import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle } from "@phosphor-icons/react";
import api, { formatApiErrorDetail } from "../lib/api";
import Logo from "../components/Logo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white p-4 sm:p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md card-flat p-6 sm:p-10">
        <Link to="/" className="flex items-center gap-3 mb-6">
          <Logo size={28} />
          <div className="font-display text-xl leading-none">TRAINA</div>
        </Link>

        {sent ? (
          <div data-testid="forgot-password-sent">
            <CheckCircle size={32} weight="duotone" className="text-emerald-400 mb-3" />
            <h1 className="font-display text-3xl mb-2">Check your inbox.</h1>
            <p className="text-zinc-400 text-sm mb-6">
              If <span className="font-mono text-white">{email}</span> is registered, we just sent a reset link.
              It expires in 30 minutes.
            </p>
            <Link to="/login" className="btn-primary w-full justify-center">Back to sign in <ArrowRight size={16} weight="bold" /></Link>
          </div>
        ) : (
          <>
            <div className="tracker mb-3 text-brand">[ Reset password ]</div>
            <h1 className="font-display text-4xl sm:text-5xl mb-2">Forgot it?</h1>
            <p className="text-zinc-400 text-sm mb-6">Drop your email — we'll send a link to set a new password.</p>
            {error && <div className="mb-4 px-4 py-3 border border-red-500/40 bg-red-500/10 text-red-300 text-sm" data-testid="forgot-error">{error}</div>}
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <label className="block">
                <div className="tracker mb-2">Email</div>
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 border" data-testid="forgot-email-input" />
              </label>
              <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="forgot-submit">
                {loading ? "Sending…" : "Send reset link"} <ArrowRight size={16} weight="bold" />
              </button>
            </form>
            <p className="mt-6 text-sm text-zinc-500">
              Remembered it? <Link to="/login" className="text-brand hover:underline">Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
